import { EquipmentMasterThemeSizeConfig } from './types';

const large: EquipmentMasterThemeSizeConfig = {
  equipmentMaster: {},
};

export default large;
